<app-full-page-message
    *ngIf="businessId && businessId.length > 5 && !localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)" />
<div
    *ngIf="!businessId || businessId.length < 5 || localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)">
    <div class="{{localService.selectedLanguageCode}} center"
        *ngIf="localService.languageContent && localService.languageContent.qr_label_gen && variables && item"
        style="max-width: 1200px;">
        <div class="banner" *ngIf="templateFor">
            <div class="row">
                <div class="col-md-4">
                    <div>
                        <app-label [Text]="localService.languageContent.qr_label_gen.template_for"
                            [IsMandatory]="true" />
                    </div>
                    <div>
                        <ngx-select [items]="templateFor" [optionValueField]="'key'" [optionTextField]="'value'"
                            placeholder="{{localService.languageContent.qr_label_gen.template_for}}"
                            [(ngModel)]="item.v1" [noAutoComplete]="true" [allowClear]="false"
                            [disabled]="item.key.length > 5" id="{{elementIds.template_for}}">
                        </ngx-select>
                    </div>
                </div>
                <div class="col-md-4">
                    <div>
                        <app-label [Text]="localService.languageContent.qr_label_gen.title" [IsMandatory]="true" />
                    </div>
                    <div>
                        <input autocomplete="off" type="text" [(ngModel)]="item.v2"
                            title="{{localService.languageContent.qr_label_gen.title}}" id="{{elementIds.title}}"
                            placeholder="{{localService.languageContent.qr_label_gen.title}}" />
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-9">
                            <div>
                                <app-label [Text]="localService.languageContent.qr_label_gen.label_diem"
                                    [IsMandatory]="true" />
                            </div>
                            <div>
                                <input autocomplete="off" type="number" class="number"
                                    (keypress)="localService.isNumberOnly($event,numericConfig)"
                                    id="{{elementIds.width}}" [(ngModel)]="item.v3" style="width:44%"
                                    placeholder="*{{localService.languageContent.qr_label_gen.width}}"
                                    title="{{localService.languageContent.qr_label_gen.width}}"
                                    [ngClass]="item.v3 ? 'en' : ''" />
                                &nbsp;
                                <input autocomplete="off" type="number" class="number"
                                    (keypress)="localService.isNumberOnly($event,numericConfig)"
                                    id="{{elementIds.height}}" [(ngModel)]="item.v4" style="width:44%"
                                    placeholder="*{{localService.languageContent.qr_label_gen.height}}"
                                    title="{{localService.languageContent.qr_label_gen.height}}"
                                    [ngClass]="item.v4 ? 'en' : ''" />
                            </div>
                        </div>
                        <div class="col-3">
                            <div
                                style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;">
                                <button type="button" class="btn btn-primary" (click)="onAction(2)">{{!item.key ?
                                    localService.languageContent.common.create :
                                    localService.languageContent.common.save}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="item.key.length > 5">
            <div class="banner center" style="max-width:800px;margin-top: 10px;">
                <div class="row row_header freeze_height">
                    <div class="col-md-6" style="text-align: left;">
                        <i class="material-icons on_language_changed" (click)="onLoadVariables()">refresh</i>
                        <i class="material-icons" (click)="onAction(1)"
                            title="{{localService.languageContent.common.add}}">note_add</i>
                        <span style="margin-left: 5px;">{{localService.languageContent.qr_label_gen.variables}}</span>
                    </div>
                    <div class="col-md-6" style="text-align: right;">
                        <button type="button" class="btn btn-primary" style="margin-right: 20px; margin-bottom: 10px;"
                            *ngIf="variables && variables.length > 0 && !isShowDeleted"
                            (click)="onAction(4)">{{localService.languageContent.qr_label_gen.sample}}</button>
                        <label style="font-weight: normal; margin-left: 15px;">
                            <input type="checkbox" [(ngModel)]="isShowDeleted" (change)="onLoadVariables()" />
                            <span class="normal_color">{{localService.languageContent.qr_label_gen.show_deleted}}</span>
                        </label>
                    </div>
                </div>
                <div class="custom_rows_body" *ngIf="variables" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
                    <div class="row styled_row" *ngFor="let item of variables">
                        <div class="col-2">
                            <i class="material-icons icon_adjust" (click)="onAction(3,item.key)" [ngClass]="{
                        'delete_icon': item.v19 =='1'
                        }">
                                {{item.v19 =='1' ? 'cancel' : 'restore'}}
                            </i>
                        </div>
                        <div class="col-10">
                            <span class="button" (click)="onAction(1,item.key)">{{item.v3}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf="item">
    <app-label-variable-config [(isOpenPopup)]="isOpenVariableConfig" [id]="selectedVariableId"
        [fontOptions]="fontOptions" [templateId]="templateId" [variableTypes]="variableTypes"
        [dynamicValuesFrom]="dynamicValuesType" [customFields]="customFields"
        (onClose)="onVariableConfigClose($event)" />
    <app-qr-label-preview-settings *ngIf="selectedTemplateFor && selectedTemplateFor > 0"
        [(isOpenPopup)]="isOpenLabelPreviewSettings" [countryCode]="ctryCode" [businessId]="businessId"
        [isSample]="true" [selectedTemplateId]="templateId" [templateFor]="selectedTemplateFor"
        (onHtmlGenerated)="onHtmlGenerated($event)" />
    <app-html-viewer [isPopUp]="true" [isIframe]="true" [printHtml]="printHtml" (onClose)="printHtml = undefined" />
</div>
<div *ngIf="businessId && businessId.length > 5">
    <span style="display: none;">
        <button class="after_access_check" (click)="onInitiate()">After Access Check</button>
    </span>
</div>